import React from 'react';
import { Map, Marker, InfoWindow, GoogleApiWrapper as GoogleMap } from 'google-maps-react';

import {googleMapDirectionLink } from './utils'
const defaultMarker =
  'data:image/png;base64,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';
const blueMarker = `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MS40ODkiIGhlaWdodD0iNjAuNzk3IiB2aWV3Qm94PSIwIDAgNDEuNDg5IDYwLjc5NyI+DQogIDxwYXRoIGlkPSJVbmlvbl8xOCIgZGF0YS1uYW1lPSJVbmlvbiAxOCIgZD0iTTMuODE4LDMyLjczOGEyMC43NDQsMjAuNzQ0LDAsMSwxLDM0LjEwOC0uMzY3TDIxLjYxOSw2MC44WiIgZmlsbD0iIzAwNjdiOSIvPg0KPC9zdmc+DQo=`;
const greyMarker = `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MS40ODkiIGhlaWdodD0iNjAuNzk3IiB2aWV3Qm94PSIwIDAgNDEuNDg5IDYwLjc5NyI+DQogIDxwYXRoIGlkPSJVbmlvbl8yMiIgZGF0YS1uYW1lPSJVbmlvbiAyMiIgZD0iTTMuODE4LDMyLjczOGEyMC43NDQsMjAuNzQ0LDAsMSwxLDM0LjEwOC0uMzY3TDIxLjYxOSw2MC44WiIgZmlsbD0iIzUyNTI1MiIvPg0KPC9zdmc+DQo=`;

class MapContainer extends React.Component {
  state = {
    bounds: '',
    activeMarker: {}


  };
  // shouldComponentUpdate(nextProps) {
  //   const { mapState } = this.props;
  //   if (mapState === nextProps.mapState) {
  //     return false;
  //   } else {
  //     return true;
  //   }
  // }

  componentDidMount() {
    const { mapState } = this.props;
    if (this.props.google) {
      debugger;
      // if ( mapState && mapState[0].location.latitude && mapState[0].location.longitude) {
      const bounds = new this.props.google.maps.LatLngBounds();

      mapState.map((marker) => {
        console.log(Number(marker && marker.location && marker.location.latitude))
        console.log(Number(marker && marker.location && marker.location.longitude))
        let lat = Number(marker && marker.location && marker.location.latitude);
        let lng = Number(marker && marker.location && marker.location.longitude);

        bounds.extend({ lat, lng });
      });
      this.setState(() => {
        return { bounds };
      });
      //   return bounds;
      //  }
    }
  }
 
  onMarkerClick = (props, marker) => {
  
   
 
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
  }


  render() {
    let {
      zoom,
      callback,
      google,
      mapState,
      markerCallback,

      customMarker,
      disableBound,
      allowZoomControl = true,
      routeMap,
      Distance,
      visible = true,
      SeeDetails,
    } = this.props;
    let options;


    return (
      <>

        <Map
          google={google}
          // {...options}
          visible={visible}
          // maxZoom={zoom}
          bounds={this.state.bounds}

          streetViewControl={false}
          scaleControl={false}
          mapTypeControl={false}
          //zoomControl={allowZoomControl}
          //onZoomChanged={zoomChanged}
          fullscreenControl={false}
          initialCenter={{
            lat: 25.0983254,
            lng: 55.0090281
          }}
        >

          {google && mapState &&
            mapState.map((marker, index) => {
              const lat = Number(marker.location.latitude);
              const lng = Number(marker.location.longitude);
             
              return (
                <Marker
                  key={index}
                  label={
                    customMarker && {
                      text: `${index + 1}`,
                      color: '#fff',

                      fontSize: '12px',
                    }
                  }
                  title={marker.title}
                  summary={marker.summary}
                  mapImage={marker.mapImage}
                  location={marker.location.title}
                  locationTitle={marker.location.title}
                  latitude={lat}
                  longitude={lng}
                
                  locationTitle={marker.location.title}
                  url={marker.url}
                  icon={
                    customMarker
                      ? {
                        url: mapState.activeMarker === index ? blueMarker : greyMarker,
                        //  anchor: new google.maps.Point(41, 60),
                        scaledSize: new google.maps.Size(41, 60),
                        labelOrigin: new google.maps.Point(20, 25),
                      }
                      : {
                        url: defaultMarker,
                        //  anchor: new google.maps.Point(34, 43),
                        scaledSize: new google.maps.Size(39, 58),
                      }
                  }
                  onClick={this.onMarkerClick}
                  position={{ lat, lng }}
                />

              );
            })}
          <InfoWindow
            marker={this.state.activeMarker}

            //pixelOffset={new google.maps.Size(100, 0)}
            visible={true}>
            {routeMap ? (
              <div className='row no-gutters custom-infowindow routemap-infowindow'>

                <div className="col-12 col-md-12 ">

                  <div className="custom-infowindow__content">


                    <h2>{this.state.activeMarker.title}</h2>
                    <p>{this.state.activeMarker.summary}</p>
                    <div className="row">
                      <div className="col-8">
                        <a target="_blank" className='btn btn-rounded btn-rounded-white-filled' href={googleMapDirectionLink(this.state.activeMarker.latitude, this.state.activeMarker.longitude)}> {SeeDetails}</a>
                      </div>
                      <div className="col-4">
                        <h4>{Distance}</h4>
                      </div>
                    </div>
                   

                  </div>
                </div>

              </div>

            ) : (


                <div className='row no-gutters custom-infowindow'>

                  <div className="col-12 col-md-7 ">

                    <div className="custom-infowindow__content">

                      <span>{this.state.activeMarker.locationTitle}</span>
                      <h2>{this.state.activeMarker.title}</h2>
                      <p>{this.state.activeMarker.summary}</p>
                      <a className='btn btn-rounded btn-rounded-white-filled' href={this.state.activeMarker.url}> {SeeDetails}</a>
                    </div>
                  </div>
                  <div className="col-12 col-md-5 custom-infowindow__img">
                    <img src={this.state.activeMarker.mapImage} alt={this.state.activeMarker.title} />
                  </div>
                </div>
              )}
          </InfoWindow>
        </Map>
      
      </>
    );
  }
}




export default GoogleMap({
  apiKey: 'AIzaSyB4GL2flAQBGxzOjrbVXQUvpU2UqJfoPo8',
  language: 'en',
})(MapContainer);

